import { fragSampler } from '../shaders/frag-sampler.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { TexturePipelineBase } from './pipeline-texBase';

export class TiledTexturePipeline extends TexturePipelineBase {
  public widthTileScalar: number;
  public heightTileScalar: number;

  public constructor(widthTileScalar: number, heightTileScalar: number) {
    super(vertSampler, fragSampler);

    this.widthTileScalar = widthTileScalar;
    this.heightTileScalar = heightTileScalar;
  }

  protected OnContextAcquired(): void {
    this.renderingContextBase = this.gl.REPEAT;
  }

  protected GetTexCoords(): number[] {
    return [
      0.0, 0.0, // TL
      0.0, this.heightTileScalar, // BL
      this.widthTileScalar, this.heightTileScalar, // BR
      this.widthTileScalar, 0.0 // TR
    ];
  }
}
